import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { WaterLogService } from 'src/app/data/repository/plan-repository/water-log.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { LoadingShared } from '../../general/shared/loading-shared';
import { PlanShared } from '../../general/shared/plan-shared';
import { WaterLogDataService } from 'src/app/data/repository/plan-repository/water-log-data.service';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { Subscription } from 'rxjs';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { ProfileService } from 'src/app/data/repository/profile-repository/profile.service';

@Component({
  selector: 'app-water',
  templateUrl: './water.component.html',
  styleUrls: ['./water.component.scss'],
})
export class WaterComponent implements OnInit, OnDestroy {
  @Input() date: Date;

  private _weightDataIsReady = false;
  @Input() set weightDataIsReady(value: boolean) {
    this._weightDataIsReady = value;
    if (value) {
      this.getWaterCount();
    } else {
      this.dataIsReady = false;
    }
  }
  get weightDataIsReady(): boolean {
    return this._weightDataIsReady;
  }

  waterLogId: string;
  waterCount = 0;
  waters = [];
  suggestedWater: number;

  dataIsReady = false;

  subscription1: Subscription;

  constructor(
    private waterLogService: WaterLogService,
    private waterLogDataService: WaterLogDataService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private planShared: PlanShared,
    private weightLogService: WeightLogService,
    private bottomsheetShared: BottomsheetShared,
    private profileService: ProfileService
  ) {
    this.subscription1 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.calculateSuggestedWater();
          }
        }
      );
  }

  ngOnInit() {
    this.calculateSuggestedWater();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
  }

  async calculateSuggestedWater() {
    const w = await this.weightLogService.getCurrentWeight();
    if (w.isSuccess()) {
      const d = await this.profileService.getCurrentDiet();
      let breastFeeding = 0;
      if (d.isSuccess()) {
        const diet = d.getData().getDiets()[0];
        breastFeeding = diet.breastFeedingDate !== 0 ? 600 : 0;
      }
      console.log(
        w.getData().getWeightLog()?.weight,
        w.getData().getWeightLog(),
        w
      );
      let weight = w.getData().getWeightLog()?.weight;

      if (!weight) {
        weight = 89;
      }
      this.suggestedWater = Math.floor((35 * weight + breastFeeding) / 250);
    } else {
      this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
    }
  }

  async getWaterCount() {
    this.dataIsReady = false;
    const waterlogApiResponse = await this.waterLogService.getWater();
    if (waterlogApiResponse.isSuccess()) {
      const waterlog = await this.waterLogDataService.getWaterLog(
        this.date.getTime()
      );
      this.waterCount = waterlog.amount;
      this.waterLogId = waterlog._id;
      // this.waters = new Array(Math.max(this.waterCount + 1, 8)).fill(0);
      this.waters = new Array(
        Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
      ).fill(0);
      this.dataIsReady = true;
    } else {
      this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      this.dataIsReady = false;
    }
  }

  addWater() {
    this.loadingShared.showLoading();
    if (this.waterLogId === '') {
      this.waterLogService
        .addWater(this.date.getTime(), this.waterCount + 1)
        .then((res) => {
          if (res.isSuccess()) {
            this.waterLogId = res.getData().getWaterlogs()[0]._id;
            this.waterCount++;
            this.waters = new Array(
              Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
            ).fill(0);
            this.planShared.waterAdded();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else {
      this.waterLogService
        .updateWater(this.waterCount + 1, this.waterLogId)
        .then((res) => {
          if (res.isSuccess()) {
            this.waterCount++;
            this.waters = new Array(
              Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
            ).fill(0);
            this.planShared.waterAdded();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    }
  }

  addCostumeWater(waterCount: number) {
    this.loadingShared.showLoading();
    if (this.waterLogId === '') {
      this.waterLogService
        .addWater(this.date.getTime(), waterCount)
        .then((res) => {
          if (res.isSuccess()) {
            this.waterLogId = res.getData().getWaterlogs()[0]._id;
            this.waterCount = waterCount;
            this.waters = new Array(
              Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
            ).fill(0);
            this.planShared.waterAdded();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else {
      this.waterLogService
        .updateWater(waterCount, this.waterLogId)
        .then((res) => {
          if (res.isSuccess()) {
            this.waterCount = waterCount;
            this.waters = new Array(
              Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
            ).fill(0);
            this.planShared.waterAdded();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    }
  }

  removeCostumeWater(waterCount: number) {
    if (this.waterCount === 1 && waterCount === 1) {
      waterCount = 0;
    }
    this.loadingShared.showLoading();
    if (this.waterLogId === '') {
      this.waterLogService
        .addWater(this.date.getTime(), waterCount)
        .then((res) => {
          if (res.isSuccess()) {
            this.waterLogId = res.getData().getWaterlogs()[0]._id;
            this.waterCount = waterCount;
            this.waters = new Array(
              Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
            ).fill(0);
            this.planShared.waterAdded();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else {
      this.waterLogService
        .updateWater(waterCount, this.waterLogId)
        .then((res) => {
          if (res.isSuccess()) {
            this.waterCount = waterCount;
            this.waters = new Array(
              Math.min(Math.ceil((this.waterCount + 3) / 8) * 8, 40)
            ).fill(0);
            this.planShared.waterAdded();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    }
  }
}
